import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { HeaderProps } from '../../types/header.types';
import { useVersionSwitcher } from '../../hooks/useVersionSwitcher';
import ChatSearchBar from './SearchBar/chat-search-bar.component';
import { CreateInvoiceButton } from './Button/primary-button.component';
import IconButton from './Button/icon-button.component';
import HelpDropdown from './HelpDropdown/help-dropdown.component';
import LanguageSelector from './LanguageSelector/language-selector.component';
import UserAvatar from './UserAvatar/user-avatar.component';
import NotificationIcon from './icons/notification.icon';
import HelpIcon from './icons/help.icon';
import ukFlag from '../../../assets/b4cd4f5d5b7374bfdf86fad7d43452f2c775ac08.png';
import './../../scss/header.style.scss';
import '../../scss/button.style.scss';
import './../../scss/language-selector.style.scss';
import './HelpDropdown/help-dropdown.style.scss';
import './../../scss/user-avatar.style.scss';
import { HeaderLogo } from '../../components/dashboard/no-invoices-yet.component';
import i18n from '../../lib/i18n';
import { getItem } from '../../helper/localstorage.helper';


const Header: React.FC<HeaderProps> = ({
  searchProps = {},
  setIsSidebarOpen = () => {},
  userProps = {},
  className = '',
  isCreateInvoicePage,
  onVersionSwitchRequest,
}) => {
  const { t } = useTranslation();
  const isMobile = window.innerWidth >= 768
  const { isV2Mode, isLoading, toggleVersion } = useVersionSwitcher();
  const handleMenuButtonClick = () => {
    setIsSidebarOpen(prev => !prev);
  };
  const location = useLocation();

    const isFaqPage = location.pathname === '/v2/faq';

  // Simple Version Switcher
  const VersionSwitcher = () => (
    <div className="header__version-switcher">
      <div className="header__version-toggle">
        <span className={`header__version-option ${!isV2Mode ? 'active' : ''}`}>V3</span>
        <button
          className={`header__toggle-switch ${isV2Mode ? 'v2' : 'v1'}`}
          onClick={() => {
            if (onVersionSwitchRequest) {
              onVersionSwitchRequest(toggleVersion);
            } else {
              toggleVersion();
            }
          }}
          disabled={isLoading}
        >
          <span className="header__toggle-slider"></span>
        </button>
        <span className={`header__version-option ${isV2Mode ? 'active' : ''}`}>V4</span>
      </div>
    </div>
  );

  return (
  <div className="header-wrapper">
    <header className={`header ${className}`}>
      <div className="header__container">
        {/* Mobile Left Section - Menu + Logo */}
        <div className="header__mobile-left">
          <button
            className="header__menu-button"
            onClick={handleMenuButtonClick}
            aria-label={t('HEADER_MENU')}
          >
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <rect width="32" height="32" rx="5" fill="white" stroke="#EAEBF0" />
              <path d="M8 10H24M8 16H24M8 22H24" stroke="#535862" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
          <Link to={`/v2/dashboard?lang=${i18n.language}`}>
            <HeaderLogo />
          </Link>

        </div>
        {/* Desktop Left Section - Search */}
              

        <div className="header__left">
          {!isFaqPage && (
          <ChatSearchBar
            placeholder={t('HEADER_SEARCH')}
            className="header__search"
            disabled={searchProps?.disabled}
          />)}
        </div>

        <div className="header__right">
          {!isCreateInvoicePage && (

            <CreateInvoiceButton
              className="header__create-button"
              label={isMobile ? t('HEADER_CREATE_INVOICE'): t('HEADER_CREATE_INVOICE_MOBILE')}
            />)}

          <div className="header__actions">
            {/* <IconButton
              icon={<NotificationIcon />}
              onClick={onNotificationClick}
              ariaLabel={t('HEADER_NOTIFICATIONS')}
              badge={notificationCount > 0 ? notificationCount : false}
              className="header__action-button"
            />

            <IconButton
              icon={<HelpIcon />}
              onClick={onHelpClick}
              ariaLabel={t('HEADER_HELP')}
              className="header__action-button header__help-button"
            /> */}

            <VersionSwitcher />
            <HelpDropdown />
            <LanguageSelector />
            <UserAvatar
              {...userProps}
              className="header__user-avatar"
            />
          </div>
        </div>
      </div>
    </header>
    </div>
  );
};

export default Header;
